(function() {
    'use strict';

    var VipAccessCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        vipAccessService,
        gestioneUtenteService,
        $uibModal
    ) {
        this.loading = 0;
        this.listaFlagNuovoDispositivo = [];
        this.gestioneUtenteService = gestioneUtenteService;
        this.dataCreazioneVip = !this.gestioneUtenteService.datiMito?.utenzaVipDto?.dataCreazione ? null : new Date(Date.parse(this.gestioneUtenteService.datiMito.utenzaVipDto.dataCreazione));

        this.readonly = this.readonly || false;

        this.cambiaStatoDispositivo = (index, flagAbilita) => {
            gestioneUtenteService.datiMito.credenzialiVip[index].statoAbilitato = flagAbilita ? 'ENABLED' : 'DISABLED';
        };

        this.eliminaDispositivo = (index) => {
            gestioneUtenteService.datiMito.credenzialiVip.splice(index, 1);
            this.listaFlagNuovoDispositivo.splice(index, 1);
        };

        this.init = () => {
            if (gestioneUtenteService.datiMito.credenzialiVip) {
                gestioneUtenteService.datiMito.credenzialiVip.forEach(cred => this.listaFlagNuovoDispositivo.push(false));
            }
        };

        this.apriModaleAggiuntaDispositivo = () => {
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/aggiuntaDispositivo/aggiuntaDispositivo.modal.html',
                controller: 'MitomAggiuntaDispositivoController',
                controllerAs: 'aggiuntaDispositivoCtrl'
            }).result.then(
                (res) => {
                    if (!!res) {
                        gestioneUtenteService.datiMito.credenzialiVip.push(res);
                        this.listaFlagNuovoDispositivo.push(true);
                    }
                }
            );
        };

        this.apriModaleEliminaVip = () => {
            let template =
            '<div class="ng-modal-overlay"></div>' +
            '<div class="row ng-modal-dialog">' +
                '<div class="col-md-12 ng-modal-dialog-content" style="margin-bottom:10px; margin-top:10px;">' +
                    '<h2 class="nome-dettaglio">ELIMINA ACCOUNT</h2>' +
                    '<p>Se si procede verranno eliminati tutti i dispositivi e l\'account VIP. Vuoi procedere?</p>' +
                '</div>' +
                '<div class="modal-footer">' +
                    '<button type="button" class="btn btn-default bfd-cancel" ng-click="cancel()">No</button>' +
                    '<button type="button" class="btn btn-default bfd-cancel" ng-click="ok()">S&igrave;</button>' +
                '</div>' +
            '</div>';
            $uibModal.open({
                template: template,
                size: 'small',
                backdrop: 'static',
                controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    // Richiamato quando si chiude il popup
                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.ok = function () {
                        $uibModalInstance.close(true);
                    };
                }]
            }).result.then(
                (res) => {
                    if (res) {
                        this.gestioneUtenteService.datiMito.utenzaVipDto.tipoOperazione = 'DELETE';
                    }
                }
            );
        };

        this.solaLettura = () => { return this.readonly || this.gestioneUtenteService.readonly };

        this.ripristina = () => { this.gestioneUtenteService.datiMito.utenzaVipDto.tipoOperazione = 'EDIT'; };

        this.vipEliminato = () => { return this.gestioneUtenteService.datiMito.utenzaVipDto?.tipoOperazione == 'DELETE' };

        this.vipClienteAssente = () => {
            let flagCliente = this.solaLettura();
            let flagUtenza = this.gestioneUtenteService.datiMito.utenzaVipDto == null;
            let flagCredenziali = !this.gestioneUtenteService.datiMito.credenzialiVip || ((this.gestioneUtenteService.datiMito.credenzialiVip.length === 0));
            return flagCliente && flagUtenza && flagCredenziali;
        };

        this.init();
    };

    VipAccessCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomVipAccessService',
        'MitomGestioneUtenteService',
        '$uibModal'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-vip-access/vipAccess.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var VipAccessComponent = {
        controller: VipAccessCtrl,
        controllerAs: 'vipAccessCtrl',
        templateUrl: TemplateUrl,
        bindings: {
            readonly: '<'
        },
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomvipAccess', VipAccessComponent);
})();